import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import maintenanceActions from '../actions/maintenance'

export const useMaintenances = () => {
  const data = useSelector((state) => {
    return get(state, 'app.maintenancesManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(maintenanceActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
